module.exports = {"540621100":"阿扎镇","540621101":"嘉黎镇","540621201":"忠玉乡","540621202":"藏比乡","540621203":"措多乡","540621204":"夏玛乡","540621206":"林堤乡","540621207":"措拉乡","540621209":"绒多乡","540621210":"鸽群乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540621.json
// module id = 2736
// module chunks = 0